export default __webpack_public_path__ + "static/media/AmericanExpress.d3fb3ad4.svg";